import React, { useState } from "react";
import { string, func } from "prop-types";

import "./password-field.m.css";

const PasswordField = ({ error, label, onTextChange, ...props }) => {
  const [isPassoword, setIsPassword] = useState(true);
  const [password, setPassword] = useState("");

  const onChange = e => {
    setPassword(e.target.value);

    if (onTextChange) {
      onTextChange(e.target.value || null);
    }
  };

  const showHide = () => setIsPassword(!isPassoword);

  return (
    <div styleName="wrapper" className="wrapper-password">
      {label && (
        <label styleName="label" className="label">
          {label}
        </label>
      )}
      <div styleName="input-wrapper">
        <input
          type={isPassoword ? "password" : "text"}
          value={password}
          styleName={error ? "password password-error" : "password"}
          className="password"
          onChange={onChange}
          {...props}
        />
        <span styleName="password_show" onClick={showHide}>
          {isPassoword ? "Show" : "Hide"}
        </span>
      </div>
      {error && <span styleName="error">{error}</span>}
    </div>
  );
};

PasswordField.propTypes = {
  error: string,
  label: string,
  onTextChange: func
};

export default PasswordField;
